<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 28/10/2021
  -->

<template>
	<v-swatches v-model="valueData"
				class="palette-color-picker-root"
				:inline="inline"
				:trigger-style="triggerStyle"
				shapes="circles"
				:swatches="colors"
				:swatch-size="colorSize"
				@update:modelValue="notifyValueChanged">
		<template #trigger>
			<!--			 v-if="$slots.default" >-->
			<slot name="default">
				<div class="trigger-container px-2 py-1 row mx-0 align-items-center flex-nowrap">
					<div class="trigger-preview circle mr-1"
						 :style="{'background-color': valueData}"/>
					<i class="fontello icon-angle-down"/>
				</div>
			</slot>
		</template>
	</v-swatches>

</template>

<script setup>
import { VSwatches } from 'vue3-swatches'
import 'vue3-swatches/dist/style.css'

</script>
<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";

// import VSwatches from 'vue3-swatches'
// import "vue3-swatches/dist/style.css"
import {defaultColorPickerPalette} from "@/core/js/PaletteEnum";

export default {
	name: "PaletteColorPicker",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		inline: {Boolean, default: false},
		triggerStyle: {Object, default: () => ({width: '12px', height: '12px'})},
		colorSize: {Number, default: 30},
		colors: {Array, default: () => defaultColorPickerPalette}
	},
	// components: {VSwatches},
}
</script>

<style lang="scss">

.palette-color-picker-root {
	.trigger-container {
		//background-color: whitesmoke;
		border-radius: 20px;
	}
	.trigger-preview {
		width: 20px;
		height: 20px;
	}

	.vue-swatches__check__circle{
		background-color: transparent;
	}
}
</style>
